// src/utils/schedule.ts
// OF-PKG1A (04.10.2026): какой день показать на экране курса — из
// расписания снапшота (enrollments[].schedule, сервер OF-PKG0,
// api/progress-rules.js buildSchedule), а не из замороженного
// current_day кэша (OF2). Чистая функция, без сети и без часов: todayYmd
// вычисляет вызывающая сторона через computeLocalDate (utils/localDate.ts)
// — вторая копия правила дня здесь не заводится.
//
// content-access, инварианты 2 и 8: это темп и отображение, не право.
// Право на контент дня и на отметку проверяет сервер (content/day,
// complete-day) на каждом обращении.
//
// schedule: null — расписание неизвестно (нет настроек курса / сбой
// чтения на сервере); undefined — снапшот из старого кэша, поля ещё не
// было. Оба → fallback на current_day, ровно прежнее поведение экрана.
// [] — окно законно пустое (курс завершён) — тоже fallback: current_day
// сервера уже за пределами курса, экран рисует его как раньше.

export type ScheduleEntry = {
  local_date: string;
  day_number: number;
  countable: boolean;
  xp: number;
};

export type TodayResolution =
  | { kind: "day"; day: number; countable: boolean; xp: number }
  | { kind: "beyond" }
  | { kind: "fallback"; day: number };

export function resolveToday({
  schedule,
  currentDay,
  durationDays,
  todayYmd,
}: {
  schedule: ScheduleEntry[] | null | undefined;
  currentDay: number;
  durationDays: number;
  todayYmd: string;
}): TodayResolution {
  if (schedule == null) return { kind: "fallback", day: currentDay };

  const hit = schedule.find((e) => e.local_date === todayYmd);
  if (hit) return { kind: "day", day: hit.day_number, countable: hit.countable, xp: hit.xp };

  // YYYY-MM-DD сравнивается строкой корректно (фиксированная ширина полей).
  const last = schedule[schedule.length - 1];
  if (last && todayYmd > last.local_date && last.day_number < durationDays) {
    return { kind: "beyond" };
  }

  return { kind: "fallback", day: currentDay };
}
